
import Brush from "../../../assets/duotone/Brush.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BrushIcon({ className, dataTestid = "BrushIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Brush data-testid={dataTestid} className={classes} {...rest} />
  );
}
